import { removeAccents } from '../utils/formating';

export interface SortOption {
  field: 'name' | 'date';
  order: 'asc' | 'desc';
}

export interface DateFilter {
  type: 'all' | 'future-events' | 'past-events' | 'this-weekend' | 'next-week' | 'next-month' | 'custom';
  startDate?: Date;
  endDate?: Date;
}

export interface EventFilters {
  sort?: SortOption;
  pattern?: string;
  dateFilter?: DateFilter;
  sport?: string;
  categories?: string[];
  country?: number;
  provinces?: number[];
}

export interface FilterProps {
  filters: EventFilters;
  onFiltersChange: (filters: EventFilters) => void;
  showSportFilter?: boolean;
  showSubsportFilter?: boolean;
  availableSports?: string[];
  availableSubsports?: string[];
  lang: string;
}

export const filtersToBackendParams = (filters: EventFilters, ignoreFilters?: {
  sort?: boolean;
  pattern?: boolean;
  dateFilter?: boolean;
  sport?: boolean;
  subsport?: boolean;
  country?: boolean;
  provinces?: boolean;
}) => {
  const params: any = {};

  if (filters.sort && !ignoreFilters?.sort) {
    const sortField = filters.sort.field === 'name' ? 'searchText' : 'data.dates.startedDateTimestamp';
    const orderDirection = filters.sort.order === 'desc' ? '(d)' : '(a)';
    params[`${orderDirection} orderBy`] = sortField;
  }

  if (filters.pattern && filters.pattern.trim() && !ignoreFilters?.pattern) {
    params['searchText(cil)'] = removeAccents(filters.pattern.trim());
  }
  
  if (filters.dateFilter && !ignoreFilters?.dateFilter) {
    const now = new Date();
    let startDate: Date;
    let endDate: Date;

    switch (filters.dateFilter.type) {
      case 'all':
        // No aplicar ningún filtro de fecha
        break;

      case 'future-events':
        startDate = new Date(now);
        startDate.setHours(0, 0, 0, 0);
        params['(ge) data.dates.startedDateTimestamp'] = startDate.getTime();
        break;

      case 'past-events':
        endDate = new Date(now);
        endDate.setHours(23, 59, 59, 999);
        params['(le) data.dates.startedDateTimestamp'] = endDate.getTime();
        break;

      case 'this-weekend':
        const dayOfWeek = now.getDay();
        const daysUntilSaturday = dayOfWeek === 0 ? 6 : 6 - dayOfWeek;
        startDate = new Date(now);
        startDate.setDate(now.getDate() + daysUntilSaturday);
        startDate.setHours(0, 0, 0, 0);

        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 1);
        endDate.setHours(23, 59, 59, 999);
        break;

      case 'next-week':
        startDate = new Date(now);
        const daysUntilNextMonday = now.getDay() === 0 ? 1 : 8 - now.getDay();
        startDate.setDate(now.getDate() + daysUntilNextMonday);
        startDate.setHours(0, 0, 0, 0);

        endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);
        endDate.setHours(23, 59, 59, 999);
        break;

      case 'next-month':
        startDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth() + 2, 0, 23, 59, 59, 999);
        break;

      case 'custom':
        if (filters.dateFilter.startDate || filters.dateFilter.endDate) {
          // Si startDate es undefined, usar la primera fecha de 1990
          startDate = filters.dateFilter.startDate ?
            new Date(filters.dateFilter.startDate) :
            new Date(1990, 0, 1);

          // Si endDate es undefined, usar la primera fecha del año 3000
          endDate = filters.dateFilter.endDate ?
            new Date(filters.dateFilter.endDate) :
            new Date(3000, 0, 1);

          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
        } else {
          break;
        }
        break;
    }

    if (startDate && endDate) {
      params['(ge) data.dates.startedDateTimestamp'] = startDate.getTime();
      params['(le) data.dates.startedDateTimestamp'] = endDate.getTime();
    }
  }

  if (filters.country && !ignoreFilters?.country) {
    params['kind'] = 'country:' + filters.country;
  }

  if (filters.provinces && filters.provinces.length > 0 && !ignoreFilters?.provinces) {
    params['data.location.provinceId'] = filters.provinces;
  }

  return params;
};